import { ComponentProps, forwardRef } from 'react'

import { FaqDataBase, FaqSettingMinimal, FrequentLayout } from '@karakuri-web/faq-type'

import { QAContent, QAHeader, QAPanel } from '../components'
import { useFaqRouting } from '../contexts/FaqRoutingContext'
import { useTopPageViewFAQs } from '../hooks/useFaqDataQuery'

interface Props<T extends FaqSettingMinimal = FaqSettingMinimal> {
  layout: FrequentLayout
  data: FaqDataBase<T>
}

/**
 * よくあるご質問ウィジェット
 * 閲覧数上位のFAQを表示する
 */
export function FaqWidget<T extends FaqSettingMinimal = FaqSettingMinimal>({
  layout,
  data,
}: Props<T>) {
  const { Link } = useFaqRouting()
  const botId = data.settingYaml.botId || ''
  const tenantId = data.settingYaml.tenantId

  const { loading, data: topFaqData } = useTopPageViewFAQs({
    botId,
    tenantId,
    skip: !botId,
  })

  if (
    loading ||
    !topFaqData ||
    !topFaqData.topPageViewFAQs ||
    topFaqData.topPageViewFAQs.length === 0
  ) {
    return null
  }

  return (
    <QAPanel className="faq-panel-frequent">
      <QAHeader title={`${layout.title || 'よくあるご質問'}`} />
      {topFaqData.topPageViewFAQs.map(x => {
        const LinkComponent = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>(
          function LinkComponent(props, ref) {
            return <Link ref={ref} {...props} to={`/answer/${x.id}/?frequent=true`} />
          }
        )
        return <QAContent key={x.id} question={x.title} LinkComponent={LinkComponent} />
      })}
    </QAPanel>
  )
}
